import Quill from 'quill';

const embedBlotName = 'embedElement';
const BlockEmbedHtml = Quill.import('blots/block/embed');
class EmbedHtmlBlot extends BlockEmbedHtml {

  static create({ value, shortId }) {
    const node = super.create();

    node.setAttribute('class', 'custom-embed-iframe');
    node.setAttribute('id', `blot-custom-id---${shortId}`);
    node.setAttribute('srcdoc', value);
    node.setAttribute('allowfullscreen', true);
    node.setAttribute('frameborder', '0');
    node.setAttribute('width', '100%');
    node.setAttribute('style', 'height: 237px;'); // Default height

    node.addEventListener('load', function () {
      setTimeout(() => {
        node.style.height = `${node.contentWindow.document.body.scrollHeight + 32}px`;

        // Disable html loaded in iframe
        const iframeDocument = node.contentDocument;  // Get document
        const style = iframeDocument.createElement('style');  // Create a style element
        style.textContent = 'body { pointer-events: none; }'; // Set css to disable pointer events
        iframeDocument.head.appendChild(style); // Add style element in document's head
      }, 2500); // Wait for 2.5 seconds before setting height of iframe
    });

    return node;
  }

  static value(node) {
    return { value: node.getAttribute('srcdoc'), shortId: node.id.split('---').at(-1) };
  }
}

EmbedHtmlBlot.blotName = embedBlotName;
EmbedHtmlBlot.tagName = 'iframe';
Quill.register(EmbedHtmlBlot);
